import { MutationList } from './mutation-list';
import {MutationTree} from "vuex";
import {navigation, progressPoints} from "@/store/types";

export type Mutations<S = navigation> = {
    [MutationList.SET_NAVIGATION_POINTS](state: S, payload: progressPoints[]): void;
    [MutationList.SET_INITIALIZATION_TO_TRUE](state: S): void;
    [MutationList.SET_CURRENT_INDEX](state: S, payload: number): void;
    [MutationList.SET_PREVIOUS_ROUTE](state: S, payload: string): void;
    [MutationList.SET_TARGET_ROUTE](state: S, payload: string): void;
    [MutationList.BACKWARD_ARROW_STATE](state: S, payload: number): void;
    [MutationList.FORWARD_ARROW_STATE](state: S, payload: number): void;
}

export const mutations: MutationTree<navigation> & Mutations = {
    [MutationList.SET_NAVIGATION_POINTS](state, payload) {
        state.points = payload;
    },
    [MutationList.SET_INITIALIZATION_TO_TRUE](state){
        state.initialization = true;
    },
    [MutationList.SET_CURRENT_INDEX](state, payload){
        state.currentIndex = payload;
    },
    [MutationList.SET_PREVIOUS_ROUTE] (state, payload) {
        state.prevRoute = payload
    },
    [MutationList.SET_TARGET_ROUTE] (state, payload) {
        state.targetRoute = payload
    },
    [MutationList.FORWARD_ARROW_STATE](state, payload){
        state.points[payload].rightArrow = true;
    },
    [MutationList.BACKWARD_ARROW_STATE](state, payload){
        state.points[payload].leftArrow = true;
    }
}